export default __webpack_public_path__ + "c39425572b39722f85d00a252fdd887b.png";